<template>
  <h3 class="heading-2 mb-24 flex items-center">
    <Flag class="mr-12" :country-code="marketCountryCode" size="l" />
    <span>{{ i18n.country(marketCountryCode) }}</span>
  </h3>
</template>

<script setup lang="ts">
import type { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

const i18n = useI18n()
defineProps<{ marketCountryCode: MarketCountryCode }>()
</script>
